// Generated by Melange

import TabsModuleCss from "./tabs.module.css";
import * as Belt__Belt_Array from "melange.belt/belt_Array.jsx";
import * as Caml_int32 from "melange.js/caml_int32.jsx";
import * as Caml_option from "melange.js/caml_option.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as Webapi__Dom__Element from "melange-webapi/Webapi/Dom/Webapi__Dom__Element.jsx";
import * as Webapi__Dom__HtmlElement from "melange-webapi/Webapi/Dom/Webapi__Dom__HtmlElement.jsx";
import Clsx from "clsx";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

const css = TabsModuleCss;

const context = React.createContext(undefined);

const make = context.Provider;

function use(param) {
  return Stdlib__Option.get(React.useContext(context));
}

const Context = {
  context: context,
  make: make,
  use: use
};

function Tabs$Root(Props) {
  let children = Props.children;
  let value = Props.value;
  const contextValue = React.useMemo((function () {
    return {
      value: value
    };
  }), [value]);
  return JsxRuntime.jsx(make, {
    value: contextValue,
    children: children
  });
}

const Root = {
  make: Tabs$Root
};

function Tabs$List(Props) {
  let children = Props.children;
  let className = Props.className;
  return JsxRuntime.jsx("div", {
    children: children,
    className: Clsx(className, css.list),
    role: "tablist",
    onKeyDown: (function ($$event) {
      Stdlib__Option.iter((function (selectedTab) {
        const tablist = $$event.currentTarget;
        const match = $$event.code;
        switch (match) {
          case "ArrowLeft" :
            $$event.preventDefault();
            const tabs = Array.prototype.slice.call(tablist.querySelectorAll("[role=tab]"));
            const currentIndex = tabs.indexOf(selectedTab, undefined);
            const len = tabs.length;
            Stdlib__Option.get(Stdlib__Option.bind(Belt__Belt_Array.get(tabs, Caml_int32.mod_((currentIndex + len | 0) - 1 | 0, len)), Webapi__Dom__HtmlElement.ofNode)).focus();
            return;
          case "ArrowRight" :
            $$event.preventDefault();
            const tabs$1 = Array.prototype.slice.call(tablist.querySelectorAll("[role=tab]"));
            const currentIndex$1 = tabs$1.indexOf(selectedTab, undefined);
            const len$1 = tabs$1.length;
            Stdlib__Option.get(Stdlib__Option.bind(Belt__Belt_Array.get(tabs$1, Caml_int32.mod_(currentIndex$1 + 1 | 0, len$1)), Webapi__Dom__HtmlElement.ofNode)).focus();
            return;
          case "End" :
            $$event.preventDefault();
            Stdlib__Option.get(Stdlib__Option.bind(Caml_option.nullable_to_opt(tablist.querySelector("[role=tab]:last-child")), Webapi__Dom__Element.asHtmlElement)).focus();
            return;
          case "Home" :
            $$event.preventDefault();
            return Stdlib__Option.iter((function (prim) {
              prim.focus();
            }), Stdlib__Option.bind(Caml_option.nullable_to_opt(tablist.querySelector("[role=tab]:first-child")), Webapi__Dom__Element.asHtmlElement));
          case "Space" :
            $$event.preventDefault();
            selectedTab.click();
            return;
          default:
            return;
        }
      }), Stdlib__Option.bind(Webapi__Dom__Element.asHtmlElement($$event.target), (function (target) {
        const role = target.role;
        if (role === "tab") {
          return Caml_option.some(target);
        } else {
          return Stdlib__Option.bind(Caml_option.nullable_to_opt(target.closest("[role=tab]")), Webapi__Dom__Element.asHtmlElement);
        }
      })));
    })
  });
}

const List = {
  make: Tabs$List
};

function Tabs$Trigger(Props) {
  let children = Props.children;
  let value = Props.value;
  const contextValue = Stdlib__Option.get(React.useContext(context));
  const isSelected = value === contextValue.value;
  const childrenProps = children.props;
  return React.cloneElement(children, {
    "aria-selected": isSelected,
    className: Clsx(childrenProps.className, css.trigger),
    role: "tab",
    tabIndex: isSelected ? 0 : -1
  });
}

const Trigger = {
  make: Tabs$Trigger
};

function Tabs$Content(Props) {
  let children = Props.children;
  let className = Props.className;
  let value = Props.value;
  const contextValue = Stdlib__Option.get(React.useContext(context));
  let tmp = {
    className: Clsx(className, css.content),
    role: "tabpanel"
  };
  if (children !== undefined) {
    tmp.children = Caml_option.valFromOption(children);
  }
  const tmp$1 = Stdlib__Option.bind(value, (function (value) {
    if (value === contextValue.value) {
      return;
    } else {
      return {
        display: "none"
      };
    }
  }));
  if (tmp$1 !== undefined) {
    tmp.style = Caml_option.valFromOption(tmp$1);
  }
  return JsxRuntime.jsx("div", tmp);
}

const Content = {
  make: Tabs$Content
};

export {
  Context,
  Root,
  List,
  Trigger,
  Content,
}
/* css Not a pure module */
